export const initialState = {
  healthConditions: [],
  healthCondition: {},
  loading: false
};
